import { H1 } from 'components/Typography'
import { LICENSES_STORE_URL } from 'app/consts'
import AvailableLicenses from './AvailableLicenses'
import AddedLicenses from './AddedLicenses'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import {
  HomeLicensingContainer,
  HomeLicensingHeader,
  VisitStoreButton,
} from './styles'
import usePermissions from 'features/auth/permissions/usePermissions'
import { ROOT_ADMIN, ROOT_USER } from 'features/auth/permissions/consts'
import { CurrentUserPermissionsContext } from 'features/auth/permissions/CurrentUserPermissionsContext'

function HomeLicensing() {
  const [hasRootUserPermission] = usePermissions({ allow: [ROOT_USER] })
  const [hasRootAdminPermission] = usePermissions({ allow: [ROOT_ADMIN] })

  // TODO: Translation
  return (
    <StyledFadeInWrapper>
      <HomeLicensingContainer>
        <HomeLicensingHeader>
          <H1>Licensing</H1>
          <VisitStoreButton
            as="a"
            href={LICENSES_STORE_URL}
            target="_blank"
            type="button"
            variant="secondary"
          >
            Visit Store
          </VisitStoreButton>
        </HomeLicensingHeader>

        <AddedLicenses />

        <CurrentUserPermissionsContext.Provider
          value={{ hasRootUserPermission, hasRootAdminPermission }}
        >
          <AvailableLicenses />
        </CurrentUserPermissionsContext.Provider>
      </HomeLicensingContainer>
    </StyledFadeInWrapper>
  )
}

export default HomeLicensing
